<template>
  <div v-if="productData" class="advCartRow">
    <div v-if="miniCart" class="text-center minicartItem">
        <div class="minicart-item-thumb">
          <img class="img-fluid minicart-item-img" :src="imageSrc" :alt="productData.productName" width="55" height="85"/>

          <img v-if="!productData.isDigital" src="/ui/main/img/book_badge.svg" alt="Book Badge" loading="lazy" width="22" height="18" class="img-fluid minicart-item-badge">
          <img v-else src="/ui/main/img/ebook_badge.svg" alt="Ebook Badge" loading="lazy" width="16" height="22" class="img-fluid minicart-item-badge">

        </div>
        <div class="cart_item_info">
          <div v-if="productData.authors && productData.authors.length > 0" class="cart_item_author">
            {{productData.authors.join(', ')}}
          </div>
          <div class="cart_item_name">
            {{ productData.productName }}
          </div>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" :hasDuplicateSignature="hasDuplicateSignature" />
          <adv-cart-product-bundle-display
            class="col-12"
            :cart-product="cartProduct"
            :product-data="productData"
          />
          <div class="cart_item_bottom">
            <div class="minicart-prices">
              <span class="minicart-price">
                {{ t('price') }}: <span v-html="finalProductPriceWithSign"></span>
              </span>
              <span class="minicart-price">
                {{ t('total') }}: <span v-html="finalTotalPriceWithSign"></span>
              </span>
            </div>
            <div class="minicart-input-col" v-if="!readOnly">
              <button @click="removeProductFromCart" :disabled="!onlineStatus" class="rem-minicart-prod" v-if="!readOnly">
                <img src="/ui/main/img/remove_from_cart_gray.svg" alt="Remove from cart" loading="lazy" width="14" height="18" class="img-fluid">
              </button>
              <adv-cart-input-spinner
                v-if="cartProduct"
                class="quantitySpinner"
                :product-id="cartProduct.productId"
                :product-code-id="cartProduct.productCodeId"
                :quantity="cartProduct.quantity"
                v-on:quantity-changed="updateProductQuantity">
              </adv-cart-input-spinner>
            </div>
            <div class="minicart-quantity" v-if="readOnly">
                <span>
                  {{ t('quantity') }}: {{ cartProduct.quantity }}
                </span>
            </div>
          </div>
        </div>
      </div>

    <div v-if="!miniCart" class="adv-cart-product-row-cart-page-item">
      <div class="cart-page-item-row">
        <div class="cart-page-item-part">
          <div class="pos-rel cart-page-item-thumb">
            <span class="cart-page-book-type" v-if="productData.isDigital">Ebook</span>
            <span class="cart-page-book-type" v-if="!productData.isDigital">Βιβλίο</span>
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img :src="imageSrc" :alt="productData.productName" class="img-fluid aspect-img" width="172" height="267">
              </div>
            </div>
          </div>

          <div class="cart-page-item-quantity-spinner mobile" v-if="!readOnly">
            <adv-cart-input-spinner
              v-if="cartProduct"
              class="quantitySpinner"
              :mini-cart="miniCart"
              :product-id="cartProduct.productId"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
        </div>

        <div class="cart-page-item-part">
          <div class="cart-page-item-authors">
            <span v-if="productData.authors && productData.authors.length > 0" class="cart-page-item-author">
              {{productData.authors.join(', ')}}
            </span>
          </div>
          <div class="cart-page-item-title">
            <a :href="productData.productUrl" class="cart-page-item-title-url">
              {{ productData.productName }}
            </a>
            <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
            <template v-if="
              'options' in cartProduct &&
              'appliedBundles' in cartProduct.options &&
              cartProduct.options.appliedBundles.length > 0
            ">
              <adv-cart-product-bundle-display
                class="col-12"
                :cart-product="cartProduct"
                :product-data="productData"
                :expanded="true"
              />
            </template>
          </div>
          <div class="cart-page-item-price">
            <span class="cart-page-item-price-title">{{ t('price') }} {{ t('package') }}:</span>
            <span v-html="finalPriceWithSign" class="cart-page-item-price-value"></span>
          </div>
          <div class="cart-page-item-quantity-spinner desktop" v-if="!readOnly">
            <adv-cart-input-spinner
              v-if="cartProduct"
              class="quantitySpinner"
              :mini-cart="miniCart"
              :product-id="cartProduct.productId"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
          <div class="cart-page-item-quantity" v-if="readOnly">
            {{ cartProduct.quantity }}
          </div>
          <div class="cart-page-item-total-row">
            <span class="cart-page-item-total-text">
                {{ t('total') }}: <span class="cart-page-item-total-price" v-html="finalTotalPriceWithSign"></span>
            </span>
          </div>
          <div class="d-flex-100 text-center cart-page-item-help-message" v-show="cartError && !readOnly">
            {{ cartError }}
          </div>
          <div class="d-flex-100 text-center cart-page-item-help-message" v-show="cartOptionError && !readOnly && hasCartProductCustomizations">
            {{ cartOptionError }}
          </div>
        </div>

        <button @click="removeProductFromCart" :disabled="!onlineStatus" class="cart-page-item-remove" v-if="!readOnly">
          <img src="/ui/main/img/remove_from_cart_gray.svg" alt="Remove from cart" loading="lazy" width="20" height="24" class="img-fluid">
        </button>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="cart-page-item-attributes">
        <span>{{ productCodeAttributes }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues
  from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AdvCartProductBundleDisplay from './AdvCartProductBundleDisplay.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvCartProductCustomizationDisplayValues,
    AdvCartProductBundleDisplay,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    },
    hasDuplicateSignature: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    hasCartProductCustomizations () {
         const check = ('options' in this.cartProduct) &&
        ('cartProductCustomizations' in this.cartProduct.options) &&
        ('groups' in this.cartProduct.options.cartProductCustomizations) &&
        (this.cartProduct.options.cartProductCustomizations.groups[0].items[0].value !== "")

      if (!check) {
        return false
      }

      if (
        '_meta' in this.cartProduct.options.cartProductCustomizations &&
        'isModified' in this.cartProduct.options.cartProductCustomizations._meta
      ) {
        return this.cartProduct.options.cartProductCustomizations._meta.isModified
      }

      return true
    },
    cartOptionError () {
      return store.getters.cartProductOptionErrorMsg(this.cartProduct.productCodeId)
    },
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalProductPriceWithSign () {
      const price = this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      const productData = store.getters.getProductById(this.cartProduct.productId)
      const cartProductData = store.getters.getCartProductById(this.cartProduct.productId)
      return {
        ...productData,
        ...cartProductData
      }
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1').small : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>

<style lang="scss" scoped>
.advCartRow {
  position: relative;
}
.cart_item_bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cart-page-item-thumb {
  background-color: #F2F5F5C4;
  padding: 20px 0;
  @media screen and (max-width:767px) {
    padding: 10px;
    margin-bottom: 10px;
    display:flex;
    width:100%;
    flex-wrap: wrap;
  }
  img {
    // object-fit: contain;
    box-shadow: 0px 3px 12px #0000005E
  }
}

.cart-page-item-part{
  @media screen and (max-width:767px){
    display: flex;
    flex-wrap: wrap;
    width:100%
  }
}
.cart-page-item-authors {
  display: grid;
  padding-top:10px;
  min-height: 40px;
  margin-bottom: 5px;
  @media screen and (max-width:767px) {
    margin-bottom: 10px;
    min-height: auto;
    flex:0 0 100%;
    max-width:100%
  }
}
.cart-page-item-author {
  color: #D2232A;
  font-size: 13px;
  @media screen and (max-width:1199px){
    padding-right:15px
  }
  @media screen and (max-width:767px) {
    font-size: 12px;
  }
}
.cart-page-item-title {
  display: grid;
  min-height: 40px;
  margin-bottom: 30px;
  @media screen and (max-width:767px) {
    margin-bottom: 5px;
    min-height: auto;
    flex:0 0 100%;
    max-width:100%
  }
}
.cart-page-item-title-url {
  color: #231F20;
  font-size: 13px;
  font-weight: 700;
  @media screen and (max-width:767px) {
    font-size: 12px;
  }
}
.cart-page-item-price {
  color: #989898;
  font-size: 13px;
  margin-bottom: 20px;
  display:block;
  width:100%;
  @media screen and (max-width:767px) {
    font-size: 12px;
    margin-bottom: 15px;
  }
}
.cart-page-item-remove {
  display: grid;
  position: absolute;
  top: 12px;
  right: 15px;
  align-items: center;
  z-index: 10;
  background-color: transparent;
  border: unset;
  padding: 0;
  @media screen and (max-width:767px) {
    top: 0;
    right: 0;
    img {
      width: 14px;
      height: 18px;
    }
  }
}
.cart-page-item-quantity-spinner {
  margin-bottom: 20px;
  @media screen and (max-width:767px) {
    margin-bottom: 0;
  }

  &.desktop {
    display: none;
    @media screen and (min-width:768px) {
      display: block;
    }
  }
  &.mobile {
    display: block;
    @media screen and (min-width:768px) {
      display: none;
    }
  }
}
.cart-page-item-total-row {
  display: flex;
}
.cart-page-item-total-text, .cart-page-item-total-price {
  font-size: 17px;
  color: #231F20;
  @media screen and (max-width:767px) {
    font-size: 14px;
  }
}
.cart-page-item-row {
  @media screen and (max-width:767px) {
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 20px;
  }
  @media screen and (max-width:575px) {
    grid-template-columns: 90px 1fr;
  }
}

.cart-page-book-type{
  position: absolute;
  background-color: #E4E4E4;
  z-index: 2;
  left:15px;
  top:10px;
  border-radius: 50px;
  font-size: 14px;
  padding:3px 10px;
  text-align:center;
  @media screen and (max-width:767px){
    background-color: rgba(228,228,228, .77);
    bottom:5px;
    top:auto;
    left:0;
    right:0;
    margin:0 auto;
    width:60px;
    font-size:13px;
    padding:1px 10px
  }
}
.minicart-prices {
  display: flex;
  flex-direction: column;
}
.minicart-item-badge {
  position: absolute;
  bottom: 3px;
  left: 3px;
}
</style>
